import easing from "../b2Editor/utils/easing";

export const blood = {
	"alpha": {
		"start": 0.82,
		"end": 0.42
	},
	"scale": {
		"start": 0.26,
		"end": 0.07,
		"minimumScaleMultiplier": 0.6
	},
	"color": {
		"start": "#c90808",
		"end": "#570101"
	},
	"speed": {
		"start": 500,
		"end": 0,
		"minimumSpeedMultiplier": 0.3
	},
	"acceleration": {
		"x": 0,
		"y": 2000
	},
	"maxSpeed": 2000,
	"startRotation": {
		"min": -25,
		"max": 25
	},
	"noRotation": false,
	"rotationSpeed": {
		"min": 0,
		"max": 200
	},
	"lifetime": {
		"min": 0.5,
		"max": 1.0
	},
	"blendMode": "normal",
	"frequency": 0.00075,
	"emitterLifetime": 0.024,
	"maxParticles": 96,
	"particleContainer": true,
	"velocityStretch": {
		"referenceSpeed": 650,
		"max": 2.4,
		"width": 0.9
	},
	"pos": {
		"x": 0,
		"y": 0
	},
	"addAtBack": false,
	"spawnType": "circle",
	"spawnCircle": {
		"x": 0,
		"y": 0,
		"r": 1
	},
	"emit":false
};
export const bloodSpray = {
	"alpha": {
		"start": 0.92,
		"end": 0.5
	},
	"scale": {
		"start": 0.36,
		"end": 0.11,
		"minimumScaleMultiplier": 0.55
	},
	"color": {
		"start": "#c90808",
		"end": "#570101"
	},
	"speed": {
		"start": 500,
		"end": 0,
		"minimumSpeedMultiplier": 0.3
	},
	"acceleration": {
		"x": 0,
		"y": 2000
	},
	"maxSpeed": 2000,
	"startRotation": {
		"min": -10,
		"max": 10
	},
	"noRotation": false,
	"rotationSpeed": {
		"min": 0,
		"max": 200
	},
	"lifetime": {
		"min": 0.5,
		"max": 1.0
	},
	"blendMode": "normal",
	"frequency": 0.004,
	"emitterLifetime": 7,
	"maxParticles": 240,
	"particleContainer": true,
	"interpolateSpawn": true,
	"maxSpawnInterpolationDistance": 360,
	"velocityStretch": {
		"referenceSpeed": 700,
		"max": 2.5,
		"width": 0.8
	},
	"connectedTrail": {
		"maxLinkDistance": 64,
		"overlap": 1.5,
		"width": 1.05,
		"scatterEvery": 4,
		"speedMultiplier": 0.9,
		"scaleMultiplier": 1,
		"lifetime": 0.55,
		"angle": 0
	},
	"pos": {
		"x": 0,
		"y": 0
	},
	"addAtBack": false,
	"spawnType": "circle",
	"spawnCircle": {
		"x": 0,
		"y": 0,
		"r": 1
	},
	"emit":false
};

// The blood drops thrown outward all around a circle at once, e.g. off the
// whole edge of a cut. Set spawnCircle.r per use.
export const bloodRing = {
	"alpha": {
		"start": 0.86,
		"end": 0.42
	},
	"scale": {
		"start": 0.3,
		"end": 0.08,
		"minimumScaleMultiplier": 0.5
	},
	"color": {
		"start": "#c90808",
		"end": "#570101"
	},
	"speed": {
		"start": 520,
		"end": 0,
		"minimumSpeedMultiplier": 0.35
	},
	"acceleration": {
		"x": 0,
		"y": 2000
	},
	"maxSpeed": 2000,
	"startRotation": {
		"min": -20,
		"max": 20
	},
	"noRotation": false,
	"rotationSpeed": {
		"min": 0,
		"max": 200
	},
	"lifetime": {
		"min": 0.5,
		"max": 1.0
	},
	"blendMode": "normal",
	"frequency": 0.0003,
	"emitterLifetime": 0.03,
	"maxParticles": 160,
	"particleContainer": true,
	"velocityStretch": {
		"referenceSpeed": 650,
		"max": 2.4,
		"width": 0.9
	},
	"pos": {
		"x": 0,
		"y": 0
	},
	"addAtBack": false,
	"spawnType": "ring",
	"spawnCircle": {
		"x": 0,
		"y": 0,
		"r": 30
	},
	"emit":false
};

// A slow drip of blood (or juice) off the bottom of a wound.
export const bloodDrip = {
	"alpha": {
		"start": 0.9,
		"end": 0.6
	},
	"scale": {
		"start": 0.2,
		"end": 0.12,
		"minimumScaleMultiplier": 0.6
	},
	"color": {
		"start": "#c90808",
		"end": "#570101"
	},
	"speed": {
		"start": 60,
		"end": 0,
		"minimumSpeedMultiplier": 0.2
	},
	"acceleration": {
		"x": 0,
		"y": 2000
	},
	"maxSpeed": 1200,
	"startRotation": {
		"min": -12,
		"max": 12
	},
	"noRotation": false,
	"rotationSpeed": {
		"min": 0,
		"max": 0
	},
	"lifetime": {
		"min": 0.6,
		"max": 1.1
	},
	"blendMode": "normal",
	"frequency": 0.07,
	"emitterLifetime": 3.5,
	"maxParticles": 70,
	"particleContainer": true,
	"velocityStretch": {
		"referenceSpeed": 600,
		"max": 2.2,
		"width": 0.85
	},
	"pos": {
		"x": 0,
		"y": 0
	},
	"addAtBack": false,
	"spawnType": "circle",
	"spawnCircle": {
		"x": 0,
		"y": 0,
		"r": 6
	},
	"emit":false
};

export const gorecloud = {
	"alpha": {
		"start": 1,
		"end": 0
	},
	"scale": {
		"start": 0.7,
		"end": 1.8,
		"minimumScaleMultiplier": 1
	},
	"color": {
		"start": "#ffffff",
		"end": "#ffffff"
	},
	"speed": {
		"start": 0.1,
		"end": 10,
		"minimumSpeedMultiplier": 1
	},
	"acceleration": {
		"x": 0,
		"y": 0
	},
	"maxSpeed": 0,
	"startRotation": {
		"min": 0,
		"max": 360
	},
	"noRotation": false,
	"rotationSpeed": {
		"min": 0,
		"max": 0
	},
	"lifetime": {
		"min": 0.2,
		"max": 0.4
	},
	"blendMode": "normal",
	"frequency": 0.02,
	"emitterLifetime": 0.24,
	"maxParticles": 24,
	"particleContainer": true,
	"pos": {
		"x": 0,
		"y": 0
	},
	"addAtBack": false,
	"spawnType": "circle",
	"spawnCircle": {
		"x": 0,
		"y": 0,
		"r": 0
    },
    "emit":false
};
export const jetfire = {
	"alpha": {
		"start": 0.52,
		"end": 0
	},
	"scale": {
		"start": 0.25,
		"end": 0.52,
		"minimumScaleMultiplier": 1
	},
	"color": {
		"start": "#ffffff",
		"end": "#29a9ff"
	},
	"speed": {
		"start": 300,
		"end": 300,
		"minimumSpeedMultiplier": 1
	},
	"acceleration": {
		"x": 0,
		"y": 0
	},
	"maxSpeed": 0,
	"startRotation": {
		"min": 265,
		"max": 275
	},
	"noRotation": false,
	"rotationSpeed": {
		"min": 50,
		"max": 50
	},
	"lifetime": {
		"min": 0.11,
		"max": 0.15
	},
	"blendMode": "normal",
	"frequency": 0.001,
	"emitterLifetime": -1,
	"maxParticles": 1000,
	"pos": {
		"x": 0,
		"y": 0
	},
	"addAtBack": false,
	"spawnType": "circle",
	"spawnCircle": {
		"x": 0,
		"y": 0,
		"r": 10
	},
	"emit":false
}

export const cannonShoot = {
	"alpha": {
		"start": 0.7,
		"end": 0
	},
	"scale": {
		"start": 1,
		"end": 0.8,
		"minimumScaleMultiplier": 1
	},
	"color": {
		"start": "#ff9900",
		"end": "#100f0c"
	},
	"speed": {
		"start": 400,
		"end": 0,
		"minimumSpeedMultiplier": 1
	},
	"acceleration": {
		"x": 0,
		"y": 0
	},
	"maxSpeed": 0,
	"startRotation": {
		"min": 0,
		"max": 360
	},
	"noRotation": false,
	"rotationSpeed": {
		"min": 0,
		"max": 200
	},
	"lifetime": {
		"min": 0.2,
		"max": 0.3
	},
	"blendMode": "normal",
	"ease": [
		{
			"s": 0,
			"cp": 0.329,
			"e": 0.548
		},
		{
			"s": 0.548,
			"cp": 0.767,
			"e": 0.876
		},
		{
			"s": 0.876,
			"cp": 0.985,
			"e": 1
		}
	],
	"frequency": 0.001,
	"emitterLifetime": 0.1,
	"maxParticles": 100,
	"pos": {
		"x": 0,
		"y": 0
	},
	"addAtBack": true,
	"spawnType": "circle",
	"spawnCircle": {
		"x": 2,
		"y": 0,
		"r": 0
	},
	"emit":false
}

export const sparksMetal = {
	"alpha": {
		"start": 1,
		"end": 0.31
	},
	"scale": {
		"start": 0.5,
		"end": 1,
		"minimumScaleMultiplier": 1
	},
	"color": {
		"start": "#fafa00",
		"end": "#ff7b00"
	},
	"speed": {
		"start": 1000,
		"end": 200,
		"minimumSpeedMultiplier": 1
	},
	"acceleration": {
		"x": 0,
		"y": 0
	},
	"maxSpeed": 0,
	"startRotation": {
		"min": -20,
		"max": 20
	},
	"noRotation": false,
	"rotationSpeed": {
		"min": 0,
		"max": 20
	},
	"lifetime": {
		"min": 0.1,
		"max": 0.3
	},
	"blendMode": "normal",
	"frequency": 0.007,
	"emitterLifetime": 0.1,
	"maxParticles": 1000,
	"pos": {
		"x": 0,
		"y": 0
	},
	"addAtBack": false,
	"spawnType": "point",
	"emit":false
}

export const grindSparks = {
	"alpha": {
		"start": 1,
		"end": 0.6
	},
	"scale": {
		"start": 0.8,
		"end": 0.35,
		"minimumScaleMultiplier": 0.6
	},
	"color": {
		"start": "#fff27a",
		"end": "#ff8a00"
	},
	"speed": {
		"start": 520,
		"end": 120,
		"minimumSpeedMultiplier": 0.5
	},
	"acceleration": {
		"x": 0,
		"y": 900
	},
	"maxSpeed": 0,
	"startRotation": {
		"min": -25,
		"max": 25
	},
	"noRotation": false,
	"rotationSpeed": {
		"min": 0,
		"max": 0
	},
	"lifetime": {
		"min": 0.08,
		"max": 0.22
	},
	"blendMode": "normal",
	"frequency": 0.012,
	"emitterLifetime": 0.05,
	"maxParticles": 80,
	"pos": {
		"x": 0,
		"y": 0
	},
	"addAtBack": false,
	"spawnType": "point",
	"emit":false
}

export const confettiFrames = [
	{
		framerate: 20,
		loop: true,
		textures: [
			"Confetti0000",
			"Confetti0001",
			"Confetti0002",
			"Confetti0003",
			"Confetti0004",
		]
	},
	{
		framerate: 20,
		loop: true,
		textures: [
			"Confetti0002",
			"Confetti0003",
			"Confetti0004",
			"Confetti0000",
			"Confetti0001",
		]
	},
	{
		framerate: 20,
		loop: true,
		textures: [
			"Confetti0004",
			"Confetti0000",
			"Confetti0001",
			"Confetti0002",
			"Confetti0003",
		]
	}
];

export const confetti = {
	"alpha": {
		"start": 1,
		"end": 1
	},
	"scale": {
		"start": 1,
		"end": 1.0,
		"minimumScaleMultiplier": 0.6
	},
	"color": {
		"start": "#e4f9ff",
		"end": "#3fcbff"
	},
	"speed": {
		"start": 500,
		"end": 100,
		"minimumSpeedMultiplier": 0.001
	},
	"acceleration": {
		"x": -0.1,
		"y": -0.1
	},
	"maxSpeed": 0,
	"startRotation": {
		"min": 0,
		"max": 360
	},
	"noRotation": false,
	"rotationSpeed": {
		"min": 1,
		"max": 7
	},
	"lifetime": {
		"min": 0.5,
		"max": 1
	},
	"blendMode": "normal",
	"frequency": 0.002,
	"emitterLifetime": 0.3,
	"maxParticles": 500,
	"pos": {
		"x": 0,
		"y": 0
	},
	"addAtBack": false,
	"spawnType": "circle",
	"spawnCircle": {
		"x": 0,
		"y": 0,
		"r": 100
	},
	"ease":easing.easeInOutQuad,
	"emit":false
}

export const splash = {
	"particleContainer": true,
	"alpha": {
		"start": 1,
		"end": 0
	},
	"scale": {
		"start": 0.1,
		"end": 0.59,
		"minimumScaleMultiplier": 2
	},
	"color": {
		"start": "#ffffff",
		"end": "#ffffff"
	},
	"speed": {
		"start": 30,
		"end": 0,
		"minimumSpeedMultiplier": 0.001
	},
	"acceleration": {
		"x": 0,
		"y": 0
	},
	"maxSpeed": 0,
	"startRotation": {
		"min": 0,
		"max": 360
	},
	"noRotation": false,
	"rotationSpeed": {
		"min": 0,
		"max": 0
	},
	"lifetime": {
		"min": 0.2,
		"max": 0.4
	},
	"blendMode": "normal",
	"frequency": 0.005,
	"emitterLifetime": 0.1,
	// A normal 100ms splash emits about 21 particles. Keep slow frames from
	// filling the old 1000-particle allowance in a single update.
	"maxParticles": 24,
	"pos": {
		"x": 0,
		"y": 0
	},
	"addAtBack": false,
	"spawnType": "circle",
	"spawnCircle": {
		"x": 0,
		"y": 0,
		"r": 20
	}
}

// Paint thrown all around when a bucket bursts. Colours are set per use.
export const paintBurst = {
	"alpha": {
		"start": 1,
		"end": 0.95
	},
	"scale": {
		"start": 0.44,
		"end": 0.2,
		"minimumScaleMultiplier": 0.45
	},
	"color": {
		"start": "#ffffff",
		"end": "#ffffff"
	},
	"speed": {
		"start": 640,
		"end": 0,
		"minimumSpeedMultiplier": 0.25
	},
	"acceleration": {
		"x": 0,
		"y": 2000
	},
	"maxSpeed": 2000,
	"startRotation": {
		"min": -25,
		"max": 25
	},
	"noRotation": false,
	"rotationSpeed": {
		"min": 0,
		"max": 200
	},
	"lifetime": {
		"min": 0.6,
		"max": 1.2
	},
	"blendMode": "normal",
	"frequency": 0.0002,
	"emitterLifetime": 0.04,
	"maxParticles": 220,
	"particleContainer": true,
	"velocityStretch": {
		"referenceSpeed": 650,
		"max": 2.2,
		"width": 0.95
	},
	"pos": {
		"x": 0,
		"y": 0
	},
	"addAtBack": false,
	"spawnType": "ring",
	"spawnCircle": {
		"x": 0,
		"y": 0,
		"r": 18
	},
	"emit": false
};

// A glug of paint thrown up out of the opening.
export const paintSplash = {
	"alpha": {
		"start": 1,
		"end": 0.95
	},
	"scale": {
		"start": 0.5,
		"end": 0.24,
		"minimumScaleMultiplier": 0.5
	},
	"color": {
		"start": "#ffffff",
		"end": "#ffffff"
	},
	"speed": {
		"start": 760,
		"end": 0,
		"minimumSpeedMultiplier": 0.35
	},
	"acceleration": {
		"x": 0,
		"y": 2000
	},
	"maxSpeed": 2000,
	"startRotation": {
		"min": -38,
		"max": 38
	},
	"noRotation": false,
	"rotationSpeed": {
		"min": 0,
		"max": 200
	},
	"lifetime": {
		"min": 0.6,
		"max": 1.1
	},
	"blendMode": "normal",
	"frequency": 0.003,
	"emitterLifetime": 0.3,
	"maxParticles": 140,
	"particleContainer": true,
	"interpolateSpawn": true,
	"maxSpawnInterpolationDistance": 360,
	"velocityStretch": {
		"referenceSpeed": 700,
		"max": 2.4,
		"width": 0.9
	},
	"pos": {
		"x": 0,
		"y": 0
	},
	"addAtBack": false,
	"spawnType": "circle",
	"spawnCircle": {
		"x": 0,
		"y": 0,
		"r": 8
	},
	"emit": false
};
